import React, { createContext, useContext, useState, useEffect } from 'react';
import { getUserDetails } from '../../Utils/apiService';

const UserContext = createContext<any>(null);

export const useUserContext = () => {
  return useContext(UserContext);
};

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
  const [userData, setUserData] = useState<any>(undefined);
  const [loading, setLoading] = useState(true);
  const [retryCount, setRetryCount] = useState(0);
  const maxRetries = 3; // Set the maximum number of retries


  const fetchUserDetails = async () => {
    try {
      const res: any = await getUserDetails();
      if (res?.data) {
        setUserData(res.data);
        setLoading(false);
      } else {
        handleRetry();
      }
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      handleRetry();
    }
  };

  const handleRetry = () => {
    if (retryCount < maxRetries) {
      setRetryCount(prevCount => prevCount + 1);
    } else {
      setUserData(null);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  useEffect(() => {
    if (userData === undefined && retryCount > 0 && retryCount <= maxRetries) {
      fetchUserDetails();
    }
  }, [userData, retryCount]);


  return (
    <UserContext.Provider value={userData}>
      {children}
    </UserContext.Provider>
  );
};
